import type { State } from 'src/replicant/State';
import { EntryPlatform } from './entry.ruleset';
import { DateTime } from 'luxon';

/**
 * Get whether the current entry is the first entry of the day, based on time and platform.
 * @param state
 * @param platform
 * @param now
 * @returns
 */
export function isFirstEntryOfToday(
  state: State,
  platform: EntryPlatform,
  now: number,
): boolean {
  const previousEntry = state.entry?.[platform]?.previousTimestamp ?? 0;
  const lastEntryDate = DateTime.fromMillis(previousEntry);
  const today = DateTime.fromMillis(now);
  return !lastEntryDate.hasSame(today, 'day');
}
